import { NODE_BACKEND_URL } from "@src/config";
import { qaBackendApiInstance } from "@src/config/config";
import axios from "axios";

export async function generateAiAvatarVideo(
  audio_url: string,
  replica_id: string,
  background_url: string,
  background_source_url: string,
  script: string,
  aiAvatarScript: boolean
) {
  const postBody = {
    script: (aiAvatarScript ||  !audio_url )? script : "",
    audio_url: audio_url,
    replica_id: replica_id || "rf7476ce9f",
    // replica_id: 'rf7476ce9f',

    background_url: background_url,
    background_source_url: background_source_url,
    background_scroll: background_url ? true : false,
    background_scroll_type: "human",
    fast:true
    // background_scroll_depth:background_url ? 'bottom' : '',
    // background_scroll_return:background_url ? 'halt' : ''
  };
  //   console.log(replica_id)
  try {
    const localEndPoint = axios.create({
      baseURL: `${NODE_BACKEND_URL}`,
    });

    const response = await localEndPoint.post(
      "/api/v1/tavus/generate-video",
      postBody
    );
    return response.data;
  } catch {
    return undefined;
  }
}

export async function getAiAvatarVideo(video_id: string) {
  const postBody = {
    video_id: video_id,
  };
  try {
    const localEndPoint = axios.create({
      baseURL: `${NODE_BACKEND_URL}`,
    });

    const response = await localEndPoint.post(
      "/api/v1/tavus/get-video",
      postBody
    );
    return response.data;
  } catch {
    return undefined;
  }
}

export async function deleteAiAvatarVideo(video_id: string) {
  const postBody = {
    video_id: video_id,
  };
  try {
    const localEndPoint = axios.create({
      baseURL: `${NODE_BACKEND_URL}`,
    });

    const response = await localEndPoint.post(
      "/api/v1/tavus/delete-video",
      postBody
    );
    return response.data;
  } catch {
    return undefined;
  }
}

// export async function 
export const fetchReplicas = async (params:any) => {
  //   const axios = getProtectedAxios();
     
    const endpoint = `https://tavusapi.com/v2/replicas`;
    
    const { data } = await axios.get(endpoint, {
      headers: {
        'x-api-key': '7b0f3944726f429bb2336ce3342bbdf0',
      },
      params, 
    });
  
    return data.data;
  };



export const getTavusList = async (replicas:string) => {
  const token = localStorage.getItem('accessToken');
  
  if (!replicas || replicas.trim() === '') {
    console.error('getTavusList called with empty replica IDs');
    return -1;
  }

  if (!token) {
    console.error('getTavusList called without access token');
    return -1;
  }

  console.log(`Calling backend API to fetch replicas: ${replicas}`);
  
  try {
    const response = await qaBackendApiInstance.get(`/video/fetch-replicas?replica_ids=${replicas}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    console.log('API response status:', response.status);
    
    if (!response.data) {
      console.error('API returned empty response');
      return -1;
    }
    
    // Log the first item if it's an array for debugging
    if (Array.isArray(response.data) && response.data.length > 0) {
      console.log('First replica in response:', JSON.stringify(response.data[0]));
    }
    const pheonixOneReplicaFilterOut = response.data.filter((replica:any) => replica.model_name !== 'phoenix-1');
    return pheonixOneReplicaFilterOut;
  } catch (error: any) {
    console.error('Error in getTavusList:', error?.message || 'Unknown error');
    if (error?.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    }
    return -1;
  }
};

// HeyGen Avatar interfaces
export interface HeyGenAvatar {
  avatar_id: string;
  avatar_name: string;
  gender: string;
  preview_image_url: string;
  preview_video_url: string;
  premium: boolean;
  type: string | null;
  tags: string[] | null;
  default_voice_id: string | null;
}

interface HeyGenAvatarsResponse {
  success: boolean;
  data: {
    avatars: HeyGenAvatar[];
    pagination: {
      total: number;
      limit: number;
      offset: number;
      count: number;
      has_more: boolean;
    };
  };
}

interface GetHeyGenAvatarsParams {
  limit?: number;
  offset?: number;
}

// Fetch HeyGen avatars
export const getHeyGenAvatars = async (params: GetHeyGenAvatarsParams = {}): Promise<{ avatars: HeyGenAvatar[]; pagination: any } | null> => {
  const token = localStorage.getItem('accessToken');
  
  if (!token) {
    console.error('getHeyGenAvatars called without access token');
    return null;
  }

  try {
    const response = await qaBackendApiInstance.get<HeyGenAvatarsResponse>(`/video/heygen-avatars`, {
      params: {
        limit: params.limit || 20,
        offset: params.offset || 0
      }
    });
    
    if (response.data && response.data.success) {
      return {
        avatars: response.data.data.avatars || [],
        pagination: response.data.data.pagination
      };
    }
    
    return null;
  } catch (error: any) {
    console.error('Error in getHeyGenAvatars:', error?.message || 'Unknown error');
    if (error?.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    }
    return null;
  }
};
